import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { H as x } from "../../base-BUIxijjU.js";
import { c as r } from "../../index-C7ezJk5b.js";
import "react";
import { capitalize as m } from "../../core/utils/string.js";
import { cssX as e, cssTI as a } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const H = ({
  columns: l,
  groups: c,
  children: w,
  className: _,
  style: D,
  id: h,
  isOpened: v,
  openOnClick: N = !0,
  onClick: u,
  isColTitlesSticky: p,
  testId: f,
  place: $ = "bottom-end",
  offset: b = void 0
}) => /* @__PURE__ */ o(
  x,
  {
    id: h,
    place: $,
    clickable: !0,
    openOnClick: N,
    variant: "light",
    offset: b,
    noArrow: !0,
    isOpen: v,
    disableStyleInjection: !0,
    className: e("TooltipDropdown"),
    children: /* @__PURE__ */ d(
      "div",
      {
        className: r(
          e("Dropdown"),
          _
        ),
        style: D,
        onClick: u,
        "data-testid": f,
        children: [
          !!l && l.map((t, n) => /* @__PURE__ */ d(
            "div",
            {
              className: e("Dropdown__column"),
              children: [
                t.title && /* @__PURE__ */ o(
                  "div",
                  {
                    className: r(
                      e("Dropdown__column-title"),
                      p && "is-sticky"
                    ),
                    "data-testid": a("text", `DropdownColumnTitle${m(t.title, !0)}`),
                    children: t.title
                  }
                ),
                /* @__PURE__ */ d("div", { className: e("Dropdown__column-content"), children: [
                  t.items.map((i, s) => /* @__PURE__ */ o(
                    "div",
                    {
                      className: e("Dropdown__row"),
                      "data-testid": a("button", `DropdownColumnItem-${n}-${s}`),
                      children: i.content
                    },
                    i.id
                  )),
                  t.content
                ] })
              ]
            },
            t.id
          )),
          !!c && /* @__PURE__ */ o("div", { className: e("Dropdown__column"), children: c.map((t, n) => /* @__PURE__ */ d(
            "div",
            {
              className: r(
                e("Dropdown__group"),
                t.hasSeparator && "is-separated"
              ),
              children: [
                t.title && /* @__PURE__ */ o(
                  "div",
                  {
                    className: r(
                      e("Dropdown__group-title"),
                      p && "is-sticky"
                    ),
                    "data-testid": a("text", `DropdownGroupTitle${m(t.title, !0)}`),
                    children: t.title
                  }
                ),
                /* @__PURE__ */ d("div", { className: e("Dropdown__group-content"), children: [
                  t.items.map((i, s) => /* @__PURE__ */ o(
                    "div",
                    {
                      className: e("Dropdown__row"),
                      "data-testid": a("button", `DropdownGroupItem-${n}-${s}`),
                      children: i.content
                    },
                    i.id
                  )),
                  t.content
                ] })
              ]
            },
            t.id
          )) }),
          w
        ]
      }
    )
  }
);
export {
  H as default
};
